import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  createAdmin,
  editAdmin,
  deleteCurrentAdmin,
  getAdminByID,
  getCategories,
} from '../../store/actions/admins/admins.action';

import PageLoader from '../../components/Common/PageLoader';
import CreateAdmin from '../../components/Admins/CreateAdmin';

import '../../styles/admin.css';

const CreateAdminContainer = () => {
  // Router hooks
  const params = useParams();
  const dispatch = useDispatch();

  // Redux state
  const isFetching = useSelector((state) => state.admin.isFetching);
  const isCreating = useSelector((state) => state.admin.isCreating);
  const currentAdmin = useSelector((state) => state.admin.currentAdmin);
  const categories = useSelector((state) => state.admin.categories);

  // Action handlers
  const handleCreateAdmin = useCallback((adminData) => {
    return dispatch(createAdmin(adminData));
  }, [dispatch]);

  const handleEditAdmin = useCallback((adminData) => {
    return dispatch(editAdmin(adminData));
  }, [dispatch]);

  const handleDeleteCurrentAdmin = useCallback((admin) => {
    return dispatch(deleteCurrentAdmin(admin));
  }, [dispatch]);

  const handleGetAdminByID = useCallback((adminId) => {
    return dispatch(getAdminByID(adminId));
  }, [dispatch]);

  const handleGetCategories = useCallback(() => {
    return dispatch(getCategories());
  }, [dispatch]);

  // Loading state
  if (isFetching) {
    return <PageLoader />;
  }

  // Prepare actions object for child component
  const actions = {
    createAdmin: handleCreateAdmin,
    editAdmin: handleEditAdmin,
    getAdminByID: handleGetAdminByID,
    getCategories: handleGetCategories,
  };

  return (
    <section className="createAdminContainer">
      <CreateAdmin
        params={params}
        adminData={currentAdmin}
        actions={actions}
        isCreating={isCreating}
        categories={categories}
      />
    </section>
  );
};

export default CreateAdminContainer;
